import { render, staticRenderFns } from "./AddOrEditRule.vue?vue&type=template&id=f59f0108&scoped=true&"
import script from "./AddOrEditRule.vue?vue&type=script&lang=js&"
export * from "./AddOrEditRule.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditRule.vue?vue&type=style&index=0&id=f59f0108&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59f0108",
  null
  
)

export default component.exports